import { render, staticRenderFns } from "./wxpay_h5.vue?vue&type=template&id=6368b3e2&scoped=true"
import script from "./wxpay_h5.vue?vue&type=script&lang=js"
export * from "./wxpay_h5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368b3e2",
  null
  
)

export default component.exports